export default __webpack_public_path__ + "static/media/img-soon-6.8eb30ab5.svg";